export default "__VITE_ASSET__CurKZ1xX__"